//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SeoMethods from '@/mixins/SeoMethods'
import Paper from '@/components/ui/Paper'
import Pageview from '@/mixins/Pageview'

export default {
  name: 'AboutPage',
  components: { Paper },
  auth: false,
  mixins: [SeoMethods, Pageview],
  layout: 'blank',
  computed: {
    isDark () {
      return this.$store.state.ui.isDarkThemeEnabled
    }
  }
}
